import axios from 'axios'
import EventBus from '@utils/eventBus'
import {
  filterInvalid,
  camel2underLine,
} from '@utils/assist'
import {
  CODE_SUCCESS,
  CODE_NO_LOGIN,
} from '@utils/constants'

axios.defaults.crossOrigin = true
axios.defaults.withCredentials = true
axios.interceptors.response.use(response => {
  const { code, data, msg } = response.data
  if (code === CODE_NO_LOGIN) EventBus.$emit('CODE_NO_LOGIN')
  if (code !== CODE_SUCCESS) {
    window.APP.$message.error(msg)
    return Promise.reject(response.data)
  }
  return data
})
axios.interceptors.response.use(response => response, error => {
  if (error.code === "ECONNABORTED") {
    window.APP.$message.error('网络超时，请刷新页面', 0)
  } else {
    window.APP.$message.error(error.message)
  }
  return Promise.reject(error)
})

const http = (url, method) => (data = {}, headers = {}) => {
  const options = {
    url: url,
    method: method,
    timeout: 40000
  }
  if (window.__xm_wx.isMiniProgram) {
    // 小程序身份信息
    options.headers = {
      'Authorization': `Bearer ${window.__xm_wx.session}`,
      'xm-applet': 1,
    }
    // 小程序登录代理商Id
    data.client_id = window.__xm_wx.clientId
  }
  options.headers = {
    ...options.headers,
    ...headers
  }

  // 因为post和get的payload不一样（data和parmas的区别）
  // 如果在axios.interceptors.request中进行拦截处理需兼容两种情况
  // 为了简单在入口统一处理
  let requestData = ''
  if (Object.prototype.toString.call(data) === '[object FormData]') {
    // formdata数据不做空值判断
    requestData = data
  } else {
    requestData = camel2underLine(filterInvalid(data))
  }
  if (method === 'post') {
    // `data` 是作为请求主体被发送的数据
    options.data = requestData
  } else {
    // `params` 是即将与请求一起发送的 URL 参数
    options.params = requestData
  }
  return axios(options)
}

export default {
  get: url => http(url, 'get'),
  post: url => http(url, 'post')
}